import { render } from "./InsertFromEmail.vue?vue&type=template&id=e8e81a30"
import script from "./InsertFromEmail.vue?vue&type=script&lang=js"
export * from "./InsertFromEmail.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__